import { cloneDeep } from "lodash";

export const setSurveyTrigger = ({ triggers, path }) => {
  triggers.path = path;

  return cloneDeep(triggers);
};

export default setSurveyTrigger;
